import { Link } from "react-router-dom";
import { Lock, MessageCircle } from "lucide-react";
import { COUPLE, EVENT } from "../constants/site";

export default function Footer() {
  const siteUrl = window.location.origin;
  const shareUrl = `https://wa.me/?text=${encodeURIComponent(
    `Confira o site do casamento de ${COUPLE.names}: ${siteUrl}`
  )}`;

  return (
    <footer className="relative overflow-hidden border-t border-gold-border bg-paperdeep">
      <img src="/images/floral-bottom.png" alt="" aria-hidden className="pointer-events-none absolute -left-16 -top-14 w-64 opacity-60" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-6 py-14 text-center">
        <img
          src="/images/monograma.png"
          alt="Monograma de Rodrigo e Talita"
          className="h-20 w-auto object-contain"
        />
        <p className="mt-4 font-script text-4xl text-ink">{COUPLE.names}</p>
        <p className="eyebrow mt-3">{COUPLE.dateLabel}</p>
        <p className="mt-4 max-w-md font-sans text-xs font-light leading-relaxed text-muted">
          {EVENT.local} — {EVENT.endereco1}, {EVENT.endereco2}
        </p>
        <a
          href={shareUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-share-btn"
          className="btn-outline mt-8"
        >
          <MessageCircle size={14} />
          Compartilhar no WhatsApp
        </a>
        <Link
          to="/admin"
          data-testid="admin-login-lock-btn"
          aria-label="Área do casal"
          className="mt-8 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-muted/60 transition-colors hover:text-sage-dark"
        >
          <Lock size={11} />
          Área do casal
        </Link>
      </div>
    </footer>
  );
}
